import React from "react";
import { connect } from "react-redux";
import { Table } from "../Table";

class ViewSingleDepartment extends React.Component {
  state = {
    isLoading: false,
    error: {},
    csvData: [],
  };

  returnTableHeaders() {
    let headers = [
      {
        title: "Name of Department",
        key: "name",
      },
      {
        title: "Available",
        key: "available",
      },
      {
        title: "Created At",
        key: "createdAt",
        isMoment: true,
        formatTime: "lll",
      },
    ];

    return headers;
  }

  render() {
    return (
      <div className="card-body">
        <Table
          data={[this.props.data]}
          isLoading={this.state.isLoading}
          headers={this.returnTableHeaders()}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(ViewSingleDepartment);
